import { MenuItem, MenuDivider } from '@szhsin/react-menu';
import { IoIosColorFilter } from 'react-icons/io';
import { MdOutlineFormatColorReset } from 'react-icons/md';
import { standardColors, themeColors } from '../../data/colors';
import './basicColorPicker.scss';
import { Box, Flex } from '@chakra-ui/react';

interface IBasicColorPickerProps {
  value: string;
  onSelect: (color: string | null) => void;
}

const BasicColorPicker: React.FC<IBasicColorPickerProps> = ({
  value,
  onSelect,
}) => {
  // #region views
  const ColorSectionTitle = ({ children }: { children: React.ReactNode }) => (
    <Box fontSize="16px" fontFamily="Lato" textAlign="center">
      {children}
    </Box>
  );

  const colorsView = (colorsList: string[]) => (
    <MenuItem
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        width: '100%',
      }}
      className="basic-color-picker-palette"
    >
      <Flex
        padding="5px"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="center"
      >
        {colorsList.map((color) => {
          const isSelected = value === color;
          return (
            <Box
              key={color}
              style={{
                backgroundColor: color,
              }}
              padding={isSelected ? '2px' : '0'}
              width="23px"
              height="23px"
              margin="2px"
              borderRadius="50%"
              transition="transform 0.25s"
              transform={isSelected ? 'scale(1.1)' : 'scale(1)'}
              cursor="pointer"
              _hover={{
                transform: 'scale(1.2)',
                boxShadow: '0 0 10px 2px rgba(17, 17, 17, 0.08)',
              }}
              onClick={() => onSelect(color)}
            />
          );
        })}
      </Flex>
    </MenuItem>
  );
  // #endregion views
  return (
    <Box style={styles.container}>
      <MenuItem onClick={() => onSelect(null)}>
        <MdOutlineFormatColorReset />
        <div style={{ marginLeft: '5px' }}>No Fill</div>
      </MenuItem>

      <MenuDivider style={{ marginTop: 0 }} />
      <ColorSectionTitle>Theme Colors</ColorSectionTitle>
      <MenuDivider />
      {colorsView(themeColors)}

      <MenuDivider style={{ marginTop: 0 }} />
      <ColorSectionTitle>Standard Colors</ColorSectionTitle>
      <MenuDivider />
      {colorsView(standardColors)}

      <MenuDivider style={{ marginBottom: 0 }} />
      <MenuItem>
        <IoIosColorFilter />
        <div style={{ marginLeft: '5px' }}>More Colors</div>
      </MenuItem>
    </Box>
  );
};

const styles = {
  container: {
    // padding: '5px',
    maxWidth: '280px',
    minWidth: '280px',
    // width: '250px',
    fontSize: '18px',
    fontFamily: 'Lato',
  } as React.CSSProperties,
};

export default BasicColorPicker;
